<template>
    <div>
        <label v-if="!templateEditing" class="vform-editor-label section">Text</label>
        <div
            v-if="!templateEditing && $store.getters.getSelectedFormLanguage === key"
            class="dflex"
            :key="index2 + 1000000000 + forceReRenderKey"
            v-for="(key, index2) in Object.keys(element.label.dix)"
        >
            <div class="col p-0">
                <textarea
                    :title="element.label.dix['Unknown']"
                    :placeholder="
                        key === 'Unknown'
                            ? placeholders.LONG
                            : $t('vform.translationMessage', {
                                  key: key,
                                  content: element.label.dix['Unknown'],
                              })
                    "
                    rows="300"
                    class="mb-1 form-text v-form-label form-text-dark"
                    type="text"
                    v-model="element.label.dix[key]"
                />
            </div>
        </div>
      <template v-if="!element.emphasized">
        <label class="vform-editor-label section">Background Color</label>
        <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
        <color-picker-and-field
            v-else
            :field-background-color="element.backgroundColor"
            @saveColor="(color) => {setItemColor('backgroundColor', color)}"
            @unsetColor="setItemColor('backgroundColor', null)"
        />

        <label class="vform-editor-label section">Font Color</label>
        <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
        <color-picker-and-field
            v-else
            :field-background-color="element.fontColor"
            @saveColor="(color) => {setItemColor('fontColor', color)}"
            @unsetColor="setItemColor('fontColor', null)"
        />


        <div
            v-if="(!selectedTemplate.backgroundColor && !selectedTemplate.fontColor) && (element.backgroundColor || element.fontColor)"
            class="settings-button d-inline-block mt-2"
            @click="element.backgroundColor = null; element.fontColor = null;">
          {{ $t('resetColor') }}
        </div><br />
      </template>

        <label v-if="!templateEditing" class="vform-editor-label section">Options</label>
        <div v-if="!templateEditing" class="col row dflex">
            <div class="dflex">
                <label
                    class="container vform-editor-body"
                    :for="'chkEmphasized' + $vnode.key"
                    >{{ $t("emphasized") }}
                    <input
                        type="checkbox"
                        :id="'chkEmphasized' + $vnode.key"
                        v-model="element.emphasized"
                    />
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js.vue";
import { vFormControls, placeholders } from "@/enum";
import SetByTemplate from "../vForm/SetByTemplate.vue";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
export default {
    name: "vFormTEXT",
    components: {
      ColorPickerAndField,
        SetByTemplate
    },
    mixins: [vFormElementMixin],
    props: {
        element: { type: Object, required: true },
        stepNo: { type: Number, required: true },
        organizationId: { type: String, default: "" },
    },
    data() {
        return {
            forceReRenderKey: 0,
            colorPickrId: null,
            vFormControls: vFormControls,
            placeholders: placeholders,
        };
    },
    beforeMount() {
        this.element.formElementType = vFormControls["TEXT"];
    },
};
</script>
